export default __webpack_public_path__ + "static/media/icon-upload-image-gray.d3867284.svg";